import { render } from "./TelemetryCard.vue?vue&type=template&id=dfe5c1cc&scoped=true"
import script from "./TelemetryCard.vue?vue&type=script&lang=js"
export * from "./TelemetryCard.vue?vue&type=script&lang=js"

import "./TelemetryCard.vue?vue&type=style&index=0&id=dfe5c1cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe5c1cc"]])

export default __exports__